export const paymentCardInfo = {
	cashPayment: "In cash",
	installmentsPayment: "Installments",
	payment: "Payment",
};
